module.exports = __webpack_public_path__ + "img/ltkeurope-4x.8b66116.jpg";